import { ReactNode } from "react";
import { useApiAuth } from "../hooks/useApiAuth";

interface ApiProviderProps {
  children: ReactNode;
}

const ApiProvider = ({ children }: ApiProviderProps) => {
  useApiAuth();
  return <>{children}</>;
};

export default ApiProvider;
